module.exports = __webpack_public_path__ + "static/img/YORK老师_轰轰.31f6a88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/YORK/YORK老师_轰轰.png
// module id = hjkJ
// module chunks = 0